var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3569 6.66659C10.3569 7.95525 9.31221 8.99992 8.02355 8.99992C6.73488 8.99992 5.69019 7.95525 5.69019 6.66659C5.69019 5.37792 6.73488 4.33325 8.02355 4.33325C9.31221 4.33325 10.3569 5.37792 10.3569 6.66659Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 1.33325C5.05456 1.33325 2.66675 3.74514 2.66675 6.72039C2.66675 8.42159 3.33341 9.74439 4.66675 10.9259C5.60655 11.7587 7.31648 13.5452 8.00008 14.6665C8.71828 13.5675 10.3936 11.7587 11.3334 10.9259C12.6667 9.74439 13.3334 8.42159 13.3334 6.72039C13.3334 3.74514 10.9456 1.33325 8.00008 1.33325Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLo);
export default __webpack_public_path__ + "static/media/lo.6a2c4990faca90fff0eb0103b7f94b02.svg";
export { ForwardRef as ReactComponent };